import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { useDocTitle } from '../components/CustomHook';
import ghostLogo from '../images/apps/ghost.svg';
import plausibleLogo from '../images/apps/plausible.svg';
import umamiLogo from '../images/apps/umami.svg';
import uptimeLogo from '../images/apps/uptimekuma.svg';
import shlinkLogo from '../images/apps/shlink.svg';

const ManagedApps = () => {
  useDocTitle('Managed Open Source Apps');
  return (
    <>
      <NavBar />
      <div className="py-16 px-4">
        <div className="max-w-4xl mx-auto mt-8 bg-white border border-gray-200 rounded-lg shadow p-8">
        <h1 className="text-3xl font-bold text-blue-900 mb-4 text-center">Managed Hosting for Open Source Apps</h1>
        <p className="text-lg text-gray-700 max-w-4xl mx-auto mb-4 text-center">
          Don’t want to babysit a VPS just to run your blog, analytics, or dashboard?
        </p>
        <p className="text-lg text-gray-700 max-w-4xl mx-auto mb-6 text-center">
          We’ll handle it for you. Get a fully managed, custom-deployed version of popular open-source tools — no setup headaches, no cloud bloat, just clean infrastructure and a human to talk to.
        </p>
        <h2 className="text-2xl font-semibold text-blue-900 mb-4 text-center">Popular apps we host:</h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 justify-items-center mb-6">
          <div className="flex flex-col items-center text-sm">
            <img src={ghostLogo} alt="Ghost" className="h-12 w-auto mb-2" />
            Ghost
          </div>
          <div className="flex flex-col items-center text-sm">
            <img src={umamiLogo} alt="Umami" className="h-12 w-auto mb-2" />
            Umami
          </div>
          <div className="flex flex-col items-center text-sm">
            <img src={plausibleLogo} alt="Plausible" className="h-12 w-auto mb-2" />
            Plausible
          </div>
          <div className="flex flex-col items-center text-sm">
            <img src={uptimeLogo} alt="Uptime Kuma" className="h-12 w-auto mb-2" />
            Uptime Kuma
          </div>
          <div className="flex flex-col items-center text-sm col-span-full sm:col-auto">
            <img src={shlinkLogo} alt="Shlink" className="h-12 w-auto mb-2" />
            Shlink
          </div>
        </div>
        <h2 className="text-2xl font-semibold text-blue-900 mb-2 text-center">What’s included:</h2>
        <ul className="list-disc list-inside text-gray-700 max-w-lg mx-auto mb-6">
          <li>Custom domain setup + SSL</li>
          <li>Automatic updates and backups</li>
          <li>Access to logs and monitoring</li>
          <li>Midwest-hosted infrastructure (fast + secure)</li>
        </ul>
        <p className="text-lg text-blue-900 font-bold text-center mb-6">Setup: $50 one-time<br />Hosting: $15/month</p>
        <div className="flex justify-center">
          <Link to="/contact" className="bg-blue-900 text-white hover:bg-blue-800 px-6 py-3 rounded-lg shadow">
            Ready to get started?
          </Link>
        </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ManagedApps;
